/* eslint-disable @next/next/no-img-element */
import React from 'react';
import styles from '@styles/Foot.module.scss';
import Link from 'next/link';
import { Col, Row } from 'antd';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

type Props = { footerInfos: any[]; rgpBanner: any };

const AppFooterBar = ({ footerInfos, rgpBanner }: Props) => {
    const [t] = useTranslation();
    // console.log(rgpBanner);
    const { RGPHeader, RGPTextOne, RGPTextTwo, RGPIcon, ItemLink } = rgpBanner.BannerItem;
    const media = (
        <div className={styles['footer-banner-media-container']}>
            <a
                className={styles['footer-banner-media']}
                href='https://mcs.hkjc.com/'
                target='_blank'
                rel='noopener noreferrer'
            >
                <div className={styles['footer-banner-media-area']}>
                    <div className={styles['footer-banner-media-icon']}></div>
                </div>
                <div className={styles['footer-banner-media-content']}>{t('rgp.media')}</div>
            </a>
        </div>
    );
    const rgpContent = (
        <div className={styles['footer-banner-rgp-content']}>
            <div className={styles['footer-play-responsibly']}>{t('rgp.playResponsibly')}</div>
            <div
                className={classNames(styles['footer-play-responsibly-content'], 'md:text-[11px]')}
            >
                <div></div>
                <div>
                    <ul></ul>
                </div>
                <div>
                    <li>{t('rgp.responsibly1')}</li>
                </div>
                <div>
                    <li>{t('rgp.responsibly2')}</li>
                </div>
                <div>
                    <li>{t('rgp.responsibly3')}</li>
                </div>
                <div></div>
            </div>
        </div>
    );
    return (
        <Row className={styles.footer}>
            {/* Destop */}
            <Col xs={0} md={24}>
                <Row className={styles.decContainer} justify='start'>
                    <Col flex={'195px'}>{media}</Col>
                    <Col className={styles.dec} flex={'1'}>
                        {rgpContent}
                    </Col>
                    <Col flex={'82px'}>
                        {/* <div className={styles.tips}></div> */}
                        <a href={ItemLink.value} target='blank' className={styles.tips}>
                            <img src={RGPIcon?.src} alt='' width='100%' />
                        </a>
                    </Col>
                </Row>
            </Col>
            {/* Mobile */}
            <Col xs={24} md={0}>
                <Row className={styles.decContainer}>
                    <Col span={14}>{media}</Col>
                    <Col span={10}>
                        {/* <div className={styles.tips}></div> */}
                        <a href={ItemLink.value} target='blank' className={styles.tips}>
                            <img src={RGPIcon?.src} alt='' width='100%' />
                        </a>
                    </Col>
                    <Col span={24} className={`${styles.dec} ${styles.decM}`}>
                        {/* <p>{t('PlayRes')}</p>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: t('footerDescription'),
                            }}
                        ></p> */}
                        {rgpContent}
                    </Col>
                </Row>
            </Col>
            <Col md={14}>
                <div className={`${styles.links}`}>
                    {footerInfos.length > 0 &&
                        footerInfos.map((item: any) => {
                            return (
                                <Link href={item?.url} key={item.label}>
                                    <a>{t(item.label)}</a>
                                </Link>
                            );
                        })}
                </div>
            </Col>
            <Col md={10} xs={0} className={styles.copyright}>
                {t('copyright.a')}
                {new Date().getFullYear()}
                {t('copyright.b')}
            </Col>
            <Col md={0} xs={24} className={styles.copyrightM}>
                {t('copyright.a')}
                {new Date().getFullYear()}
                {t('copyright.b')}
            </Col>
        </Row>
    );
};

export default AppFooterBar;
